<template>
<div class="">
    <div class="heading-colors">
        <span>{{ $t('customcolor.text_6') }}</span>
    </div>
    <div class="colors-pallete mb-3">
        <div @click="hexa = color" class="button" :class="{active : hexa==color}" v-for="color in colors" :key="color.id">
            <div :style="'background: ' + color" class="color" ></div>
        </div>
    </div>
    <div class="d-flex justify-content-center align-items-center mb-3 or">
            {{ $t('customcolor.text_7') }}
    </div>
    <div class="c-range">
        <div class="left">
            <div :style="'background-color: ' + hexa" class="circle_colorpicker"></div>
            <div class="sliders">
              <div class="c-range__holder mb-2">
                  <input v-model.number="degrees" class="c-range__slider js-range-input" id="hue" type="range" min="0" max="360">
              </div>
              <div class="c-range__holder_white_black">
                  <input v-model.number="rgb" class="c-range__slider_white_black js-range-input" id="hue" type="range" min="0" max="255">
              </div>
            </div>
        </div>
        <div class="right">
          <input v-model="hexa" placeholder="#fffffff" class="hex-input" type="text">
        </div>
    </div>
    <div v-if="!card" class="result">
      <div>{{ $t('customcolor.text_8') }}</div>
        <color-image :hexa = 'hexa'/>
    </div>
</div>
</template>

<script>
import ColorImage from './ColorImage.vue'
    export default {
        props: ['offercolor','card'],
        components: { ColorImage },
        data() {
            return {
                degrees: 180,
                hexa: "#F3385A",
                rgb: null,
                colors: [
                    '#F3385A',
                    '#FFC800',
                    '#00FFCD',
                    '#F93C34',
                    '#7F31CD',
                    '#FDBCA0',
                    '#263544',
                    '#DB00FF',
                    '#FF0000'
                ]
            }
        },
        mounted () {
          if(this.offercolor)
            this.hexa = this.offercolor
          else
            this.hexa = "#F3385A"
        },
        watch: {
            degrees() {
              this.hslToHex()
            },
            rgb(){
              this.rgbToHex()
            },
            hexa(){
              this.$emit('getColor', this.hexa)
            },
            offercolor(){
              if(this.offercolor)
                this.hexa = this.offercolor
            }
        },
        created () {
            this.hslToHex()
        },
        methods: {
            hslToHex() {
                var s = 100;
                var l = 50;
                var h = this.degrees;
                h /= 360;
                s /= 100;
                l /= 100;
                let r, g, b;
                if (s === 0) {
                    r = g = b = l; // achromatic
                } else {
                    const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                    };
                    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    const p = 2 * l - q;
                    r = hue2rgb(p, q, h + 1 / 3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1 / 3);
                }
                const toHex = x => {
                    const hex = Math.round(x * 255).toString(16);
                    return hex.length === 1 ? '0' + hex : hex;
                };
                this.hexa = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
                    
            },
            componentToHex() {
                var rgb = 255 - this.rgb
                var hex = rgb.toString(16)
                return hex.length == 1 ? "0" + hex : hex
            },
            rgbToHex(){
                this.hexa = "#" + this.componentToHex() + this.componentToHex() + this.componentToHex()
            }
            
        },
        
        
    }

</script>

<style lang="scss" scoped>

svg{
  width: 477px;
}

$track-h: 14px;
$track-h-wb: 5px;
$thumb-d: 13px;

@mixin track_black_white() {
	border: none;
	width: 100%; 
  height: $track-h-wb;
	border-radius: 4px;
  
  background: linear-gradient(
    to right,
    white 0%,
    black 100%
  );
}

@mixin track() {
	border: none;
	width: 100%; 
  height: $track-h;
	border-radius: 4px;
  
  background: linear-gradient(
    to right,
    #ff0000 0%,
    #ffff00 17%,
    #00ff00 33%,
    #00ffff 50%,
    #0000ff 67%,
    #ff00ff 83%,
    #ff0000 100%
  );
}

@mixin thumb() {
  border: 2px solid black;
	width: $thumb-d; 
  height: $thumb-d;
	border-radius: 50%;
	background: transparent;
  box-shadow: var(--box-shadow);
}
.heading-colors{
    width: 100%;
    margin:27px auto 15px auto;
    @media screen and (max-width: 600px) {
      width: 100%;
      text-align:center;
    }
    span{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: #263544;
    }
}
.result{
    width: 100%;
    margin:30px auto 8px auto;
    @media screen and (max-width: 600px) {
      width: 100%;
      text-align:center;
    }
    div{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 150%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #404040;
        margin-bottom:8px;
    }
    svg{
      @media screen and (max-width: 600px) {
        width: 90%;
        margin: 0 auto;
        display: block;
        height: 200px;
      }
    }
    
}
.colors-pallete{
    background:transparent;
    display:flex;
    justify-content:space-between;
    width: 100%;
    margin:0 auto;
    &{
      @media screen and (max-width: 600px) {
        width: 95%;
      }
    }
    .button.active{
            border: 1px solid #2ED8B6;
            border-radius: 3px;
        }
    .button{
        background: #FFFFFF;
        border-radius: 3px;
        border:1px solid transparent;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor:pointer;
        box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
        
        .color{
            width: 20px;
            height: 20px;
            border: 1px solid #E4EAEF;
            box-sizing: border-box;
            border-radius: 4px;
            
        }
        
    }
}
.or{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #263544;
}
.c-range {
    display: flex;
    width: 100%;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        width: 95%;
        display:block;
    }
    
    position: relative;
    background: transparent;
    border-radius: var(--border-radius);
    display: flex;
    .right{
      @media only screen and (max-width: 600px) {
        display: block;
        text-align: center;
        margin-top: 25px;
      }
      
    }
    .left{
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width: 65%;
      height: 50px;
      margin-right: 11px;
      background: #FFFFFF;
      border-radius: 3px;
      @media only screen and (max-width: 600px) {
        width: 100%;
      }
      .circle_colorpicker{
          width: 35px;
          height:35px;
          border-radius:50%;
          background-color: var(--color-alpha);
      }
      .sliders{
          .c-range__holder_white_black{
              display: flex;
              align-items: center;
              position: relative;
              width: 170px;
              .c-range__slider_white_black{
                  width: 100%;
                  margin: 0;
                  padding: 0;
                  min-height: $thumb-d;
                  background: transparent;
                  outline: none;
                  
                  &, &::-webkit-slider-thumb {
                    -webkit-appearance: none;
                  }
                  
                  &::-webkit-slider-runnable-track {
                    @include track_black_white();
                  }
                  &::-moz-range-track { @include track_black_white; }
                  &::-ms-track { @include track_black_white; }
                  
                  &::-webkit-slider-thumb {
                    margin-top: .5*($track-h-wb - $thumb-d);
                    @include thumb;
                  }
                  &::-moz-range-thumb { @include thumb; }
                  &::-ms-thumb {
                    margin-top: 0;
                    @include thumb;
                  }
                  
                  &::-ms-tooltip { display: none }
                  
                  &:focus,
                  &:active { 
                    + .c-range__output {
                      opacity: 1;
                    }
                  }
              }
          }
          .c-range__holder {
              display: flex;
              align-items: center;
              position: relative;
              width: 170px;
              .c-range__slider {
                  width: 100%;
                  margin: 0;
                  padding: 0;
                  min-height: $thumb-d;
                  background: transparent;
                  outline: none;
                  
                  &, &::-webkit-slider-thumb {
                    -webkit-appearance: none;
                  }
                  
                  &::-webkit-slider-runnable-track {
                    @include track();
                  }
                  &::-moz-range-track { @include track; }
                  &::-ms-track { @include track; }
                  
                  &::-webkit-slider-thumb {
                    margin-top: .5*($track-h - $thumb-d);
                    @include thumb;
                  }
                  &::-moz-range-thumb { @include thumb; }
                  &::-ms-thumb {
                    margin-top: 0;
                    @include thumb;
                  }
                  
                  &::-ms-tooltip { display: none }
                  
                  &:focus,
                  &:active { 
                    + .c-range__output {
                      opacity: 1;
                    }
                  }
              }
          }
      }
    }
}
.hex-input{
    background: #FFFFFF;
    border: 1px solid #DDE3E8;
    border-radius: 3px;
    width: 198px;
    height:50px;
    padding: 12px 21px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
    margin-left:15px;
    text-transform: uppercase;
}
.hex-input::-webkit-input-placeholder { /* Edge */
 color: rgba(33, 37, 65, 0.3);
}

.hex-input:-ms-input-placeholder { /* Internet Explorer */
 color: rgba(33, 37, 65, 0.3);
}
.hex-input::placeholder {
 color: rgba(33, 37, 65, 0.3);
}

@media screen and (max-width: 640px) {
}
</style>
